module.exports = __webpack_public_path__ + "img/dksh.88b0ef77.png";